import { createAsyncThunk } from "@reduxjs/toolkit";
import config from '../../config.js'

const API_URL = config.API_URL; // URL da API

/**
 * Thunk para buscar todos os dashboards.
 */
export const fetchDashboards = createAsyncThunk(
  "dashs/fetchDashboards",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_URL}/dash/dashboards`);
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ message: "Erro ao buscar dashboards" }));
        throw new Error(errorData.message);
      }
      return await response.json();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

/**
 * Thunk para buscar um dashboard pelo ID.
 */
export const fetchDashboardById = createAsyncThunk(
  "dashs/fetchDashboardById",
  async (dashboardId, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_URL}/dash/dashboard/${dashboardId}`);
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ message: "Erro ao buscar o dashboard" }));
        throw new Error(errorData.message);
      }
      return await response.json();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

/**
 * Thunk para criar um dashboard.
 */
export const saveDashboard = createAsyncThunk(
  "dashs/saveDashboard",
  async (dashboardData, { rejectWithValue }) => {
    const { dashboardName, dashboardDescription, datoramaUrl, selectedGroups } = dashboardData;
    try {
      const response = await fetch(`${API_URL}/dash/dashboard`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          dashboardName,
          dashboardDescription,
          datoramaUrl,
          selectedGroups,
        }),
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || "Erro ao salvar dashboard");
      }
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

/**
 * Thunk para atualizar um dashboard.
 */
export const updateDashboard = createAsyncThunk(
  "dashs/updateDashboard",
  async (dashboardData, { rejectWithValue }) => {
    const { id, dashboardName, dashboardDescription, dashboardUrl, readers, groups } = dashboardData;
    if (!id) return rejectWithValue("ID do dashboard é obrigatório para atualização.");
    try {
      const response = await fetch(`${API_URL}/dash/dashboard/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ dashboardName, dashboardDescription, dashboardUrl, readers, groups }),
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || "Erro ao atualizar dashboard");
      }
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

/**
 * Thunk para deletar um dashboard.
 */
export const deleteDashboard = createAsyncThunk(
  "dashs/deleteDashboard",
  async (dashboardId, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_URL}/dash/dashboard/${dashboardId}`, {
        method: "DELETE",
      });
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ message: "Erro ao deletar o dashboard" }));
        throw new Error(errorData.message);
      }
      return dashboardId; // Retorna apenas o ID para remover do estado
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
